/**
 * @Author: DJ
 * @Date:   2021-07-08 16:21:56
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-07-08 16:28:43
 */
/**
 *  参数设置
 * */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './index.module.scss';
import { message, InputNumber, Spin, Empty, Switch, Checkbox, Input } from 'antd';
import { XOKButton, } from '@/components/xqxc_ui';
import http from '@/assets/api/http';
import PropTypes from 'prop-types';
import model from '@/reducers/system/parameter/model';
import { regYuanToFen, regFenToYuan } from '@/util/money';
import { FloatConversion } from '@/util/conversion';

class RiskControl extends Component {
    state = {
        loading: false,
        floatConversion: new FloatConversion(),
        riskList: [],//渲染的数据
        spinLoading: true,
    };

    componentDidMount() {
        this.props.getlistAdminParamByParamType({ paramType: 'PIG_LIMIT_SET' });
    }

    componentDidUpdate(prevProps) {
        if (this.props.listAdminParamByParamType !== prevProps.listAdminParamByParamType) {
            this.renderRisk(this.props.listAdminParamByParamType);
        }
    }

    //保存
    _savehandle = () => {
        const { riskList, floatConversion } = this.state;
        let submit = riskList.map((item) => {
            if (item.paramCode == 'HELP_BUY_HIGHEST_MONEY' || item.paramCode == 'TIP_HIGHEST_MONEY') {
                return { paramCode: item.paramCode, paramValue: Number(regYuanToFen(item.paramValue)) }
            } else {
                return { paramCode: item.paramCode, paramValue: item.paramValue };
            }
        });

        for (let item of riskList) {
            if (item.paramCode === 'ALI_PHONE_WARINING_SMS_TEL' && item.paramValue && item.paramValue !== '') {
                let regList = item.paramValue.split(',');
                if (regList && regList.length > 0) {
                    const reg = new RegExp(/^1[3|4|5|6|7|8|9][0-9]{9}$/);
                    for (let it of regList) {
                        if (!reg.test(it)) {
                            message.warning('请检查报警短信名单手机号格式是否错误');
                            return false;
                        }
                    }
                }
            }
        }

        this.setState({ loading: true }, () => {
            http('/?cmd=com.xqxc.api.pig.mis.biz.platform.AdminParamMisService.batchSaveParam', { list: submit }, 'POST').then((response) => {
                message.success('保存成功');
                this.props.getlistAdminParamByParamType({ paramType: 'PIG_LIMIT_SET' });
                this.setState({ loading: false });
            }).catch((e = {}) => {
                message.error(e.message);
                this.setState({ loading: false });
            });
        });
    }

    renderRisk = (obj) => {
        const { floatConversion } = this.state;
        let risk = [];
        if (Object.keys(obj).length > 0) {
            let arr = [];
            for (let key in obj) {
                arr.push(obj[key]);
            }

            // 产品说这两项要过滤掉
            arr = arr.filter((item) => {
                if (item.paramCode == 'RIDER_SYS_CANCEL_TIME_LIMIT' ||
                    item.paramCode == 'RIDER_SYS_AFTER_TIME_LIMIT' ||
                    item.paramCode == 'RIDER_SYS_APPEAL_TIME_LIMIT' ||
                    item.paramCode == 'RIDER_APPEAL_DAY' ||
                    item.paramCode == 'ENTERPRISE_SUB_ACCOUNT_NUMBER' ||
                    item.paramCode == 'MANY_ORDER_RECEIVER_NUMBER' ||
                    item.paramCode == 'ALIPHONE_BIND_EXPIRATION' ||      // hide
                    item.paramCode == 'ALIPHONE_UNBIND_DELAY' ||           // hide
                    item.paramCode == 'RIDER_DELIVERY_ARRIVE_IMG'
                ) {
                    return false;
                } else {
                    return true;
                }
            });

            risk = arr.map((v) => {
                switch (v.paramCode) {
                    case 'DELIVER_CAN_HELP_NUM'://配送订单可以求助的次数
                        {
                            v.atype = 'InputNumber';
                            v.attr = '配送订单可以求助的次数';
                            v.aprecision = 0;
                            v.amin = 1;
                            v.amax = 10;
                            v.aremark = '同一个配送订单可以发起求助的最大次数（单位：次）';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'USER_CAN_COMPLAIN_PERIOD'://用户可以投诉的周期
                        {
                            v.atype = 'InputNumber';
                            v.attr = '用户可以投诉的周期';
                            v.aprecision = 0;
                            v.amin = 1;
                            v.amax = 9999;
                            v.aremark = '骑士完成后，用户操作投诉的期限，超过期限不得发起投诉（单位：分钟）';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'USER_COMPLAIN_PROCESSING_TIME'://用户投诉处理时效
                        {
                            v.atype = 'InputNumber';
                            v.attr = '用户投诉处理时效';
                            v.aprecision = 0;
                            v.amin = 0;
                            v.amax = 9999;
                            v.aremark = '用户申请投诉，平台需要在指定时间内进行处理，超时后订单金额金额退回用户（单位：分钟）';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'COMPANY_CAN_COMPLAIN_PERIOD'://企业可以投诉的周期
                        {
                            v.atype = 'InputNumber';
                            v.attr = '企业可以投诉的周期';
                            v.aprecision = 0;
                            v.amin = 0;
                            v.amax = 9999;
                            v.aremark = '骑士完成后，企业操作投诉的期限，超过期限不得发起投诉（单位：分钟）';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'COMPANY_COMPLAIN_PROCESSING_TIME'://企业投诉处理时效
                        {
                            v.atype = 'InputNumber';
                            v.attr = '企业投诉处理时效';
                            v.aprecision = 0;
                            v.amin = 0;
                            v.amax = 9999;
                            v.aremark = '企业用户申请投诉，平台需要在指定时间内进行处理，超时后订单金额金额退回企业（单位：分钟）';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'RIDER_POSITION_DEVIATION'://骑士定位容错范围
                        {
                            v.atype = 'InputNumber';
                            v.attr = '骑士定位容错范围';
                            v.aprecision = 0;
                            v.amin = 0;
                            v.amax = 100;
                            v.aremark = '用于到店或确认送达时确认骑士当前位置与目标位置之间的距离，允许偏差的距离（单位：米）';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'RIDER_ORDER_RANGE'://骑士接收配送单范围
                        {
                            v.atype = 'InputNumber';
                            v.attr = '骑士接收配送单范围';
                            v.aprecision = 0;
                            v.amin = 0;
                            v.amax = 10000;
                            v.aremark = '根据骑士定位刷新接单页面时推送指定范围内的配送单（单位：米）';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'HELP_BUY_HIGHEST_MONEY'://帮我买最高商品预估金额
                        {
                            v.atype = 'InputNumber';
                            v.attr = '帮我买最高商品预估金额';
                            v.aprecision = 0;
                            v.amin = 1;
                            v.amax = 999;
                            v.aremark = '最高可预估商品价值的商品（单位：元）';
                            v.paramValue = Number(regFenToYuan(v.paramValue));
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'TIP_HIGHEST_MONEY'://小费最高金额
                        {
                            v.atype = 'InputNumber';
                            v.attr = '小费最高金额';
                            v.aprecision = 0;
                            v.amin = 1;
                            v.amax = 999;
                            v.aremark = '配送订单小费最高金额（单位：元）';
                            v.paramValue = Number(regFenToYuan(v.paramValue));
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'DELIVER_MAX_DISTANCE'://配送订单最大距离
                        {
                            v.atype = 'InputNumber';
                            v.attr = '配送订单最大距离';
                            v.aprecision = 0;
                            v.amin = 1;
                            v.amax = 999;
                            v.aremark = '配送订单最大的公里数（单位：千米）';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'ADDED_VALUE_ORDER_HESITATE_TIME'://增值服务订单犹豫期
                        {
                            v.atype = 'InputNumber';
                            v.attr = '增值服务订单犹豫期';
                            v.aprecision = 0;
                            v.amin = 1;
                            v.amax = 99;
                            v.aremark = '成为经纪人完成增值服务订单支付后，在需要支付时间加此项配置才可以完成订单执行分润（单位：小时）';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'RIDER_CUT_OPERATION_INTERVAL_DAY'://骑士切换运营公司间隔天数
                        {
                            v.atype = 'InputNumber';
                            v.attr = '骑士切换运营公司间隔天数';
                            v.aprecision = 0;
                            v.amin = 1;
                            v.amax = 9999;
                            v.aremark = '骑士每次切换运营公司要满足间隔天数后，才可以切换运营公司。（单位：天）';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'DEVELOP_BROKER_AUTO_AUDIT'://发展经纪人自动审核
                        {
                            v.atype = 'Switch';
                            v.attr = '发展经纪人自动审核';
                            v.aprecision = 0;
                            v.amin = 0;
                            v.amax = 100;
                            v.component = 'Switch';
                            v.aremark = '定义成为经纪人开启自动审核；未开启则人工审核；(0:未开启，1:开启)';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'RIDER_APPEAL_DAY'://骑士申诉期时长
                        {
                            v.atype = 'InputNumber';
                            v.attr = '骑士申诉期时长';
                            v.aprecision = 0;
                            v.amin = 0;
                            v.amax = 100;
                            v.aremark = '骑士收到罚单后，可申诉的期限，超过时间后不可再起申诉(单位：天)';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'ENTERPRISE_SUB_ACCOUNT_NUMBER'://企业子账号数量
                        {
                            v.atype = 'InputNumber';
                            v.attr = '企业子账号数量';
                            v.aprecision = 0;
                            v.amin = 1;
                            v.amax = 100;
                            v.aremark = '定义企业会员子账号数量。（单位：个）';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'MANY_ORDER_RECEIVER_NUMBER'://一路多单新增收货人数
                        {
                            v.atype = 'InputNumber';
                            v.attr = '一路多单新增收货人数';
                            v.aprecision = 0;
                            v.amin = 2;
                            v.amax = 9;
                            v.aremark = '定义一路多单收货人数量。（单位：个）';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'RECON_DEFAULT_GENER_DAY'://对账单默认生成时间
                        {
                            v.atype = 'InputNumber';
                            v.attr = '对账单默认生成时间';
                            v.aprecision = 0;
                            v.amin = 1;
                            v.amax = 28;
                            v.aremark = '定义运营公司对账单和企业对账单系统默认生成时间';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'USER_AVATAR_NICKNAME_AUTO_AUDIT'://普惠用户修改头像/昵称自动审核
                        {
                            v.atype = 'CheckboxGroup';
                            v.attr = '普惠用户修改头像/昵称自动审核';
                            v.aremark = '普惠用户修改头像、昵称是否自动审核';
                            v.list = [
                                { label: '头像', value: 'first' },
                                { label: '昵称', value: 'last' }
                            ];
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'RIDER_AVATAR_NICKNAME_AUTO_AUDIT'://普惠骑士修改头像/昵称自动审核
                        {
                            v.atype = 'CheckboxGroup';
                            v.attr = '普惠骑士修改头像/昵称自动审核';
                            v.aremark = '普惠骑士修改头像、昵称是否自动审核';
                            v.list = [
                                { label: '头像', value: 'first' },
                                { label: '昵称', value: 'last' }
                            ];
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'VIRTUAL_REAL_NO_CONFIG'://虚拟号过期允许使用本机号码拨打
                        {
                            v.atype = 'CheckboxGroup';
                            v.attr = '虚拟号过期允许使用本机号码拨打';
                            v.aremark = '勾选时允许用户端、骑士端在虚拟号未绑定或失效的情况下使用本机号码联系对方';
                            v.list = [
                                { label: '用户端', value: 'first' },
                                { label: '骑士', value: 'last' }
                            ];
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'RIDER_INSURE_POLICY_PAYMENT_MODE_SWITCH'://骑士保单微信、支付宝支付方式
                        {
                            v.atype = 'Switch';
                            v.attr = '骑士保单微信、支付宝支付方式';
                            v.aremark = '骑士账户余额不足时可使用微信、支付宝支付保单';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'ALI_PHONE_WARINING_SMS_TEL':
                        {
                            v.atype = 'TextArea';
                            v.attr = '虚拟号不够用时，接受报警短信名单';
                            v.aremark = '设置虚拟号不够用时，接收报警信息人员名单；填入接收人手机号，并以英文逗号”,”隔开';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'OC_PLAT_MATERIAL':
                        {
                            v.atype = 'TextArea';
                            v.attr = v.paramAttr;
                            v.aremark = v.remark;
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'ALI_PHONE_WARINING_INTERVAL':
                        {
                            v.atype = 'InputNumber';
                            v.attr = '虚拟号不够用时，报警时间间隔';
                            v.aremark = '虚拟号不够用时，接收报警信息的时间间隔设置，间隔单位为小时';
                            v.amin = 1;
                            v.amax = 9999;
                            v.aprecision = 0;
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'ALIPHONE_UNBIND_DELAY':
                        {
                            v.atype = 'InputNumber';
                            v.attr = '订单取消完成后虚拟号解绑延迟时间（分）';
                            v.aremark = '订单取消完成后虚拟号解绑延迟时间（分）';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'ALIPHONE_BIND_EXPIRATION':
                        {
                            v.atype = 'InputNumber';
                            v.attr = '虚拟号过期時間（分）';
                            v.aremark = '虚拟号过期時間（分）';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'SMART_ORDER_RANGE':
                        {
                            v.atype = 'InputNumber';
                            v.attr = '智能调度派单附近骑士';
                            v.aremark = '根据派订单坐标位置，获取指定范围内的骑士（单位：米）';
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'RIDER_TRANSFER_NUM_LIMIT':
                        {
                            v.atype = 'InputNumber';
                            v.attr = '骑手每天转单次数限制';
                            v.aremark = '众包骑手每天最高能成功转几次单';
                            v.amin = 1;
                            v.amax = 20;
                            v.aprecision = 0;
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'RIDER_TRANSFER_DISTANCE_LIMIT':
                        {
                            v.atype = 'InputNumber';
                            v.attr = '骑手转单范围限制';
                            v.aremark = '设置后，骑手仅能转给距离取件点多少范围内的骑手进行抢单（单位:km）';
                            v.amin = 1;
                            v.amax = 10;
                            v.aprecision = 0;
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'RIDER_TRANSFER_TIME_LIMIT':
                        {
                            v.atype = 'InputNumber';
                            v.attr = '骑手转单时间限制';
                            v.aremark = '转单后多少时间无人抢单推送转单失败弹框（单位:分钟）';
                            v.amin = 1;
                            v.amax = 30;
                            v.aprecision = 0;
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                }
                return v;
            });

        }
        this.setState({ riskList: risk, spinLoading: false });
    }

    render() {
        const { loading, riskList, spinLoading } = this.state;

        return (
            <div className={styles.flexBoxContainer}>
                <div className={styles.tableContainer} style={{ overflow: 'hidden auto' }}>
                    <div className={styles.spin}><Spin spinning={spinLoading} size='large' /></div>
                    {(!spinLoading && riskList.length > 0) ? riskList.map((v, index) => {
                        return (
                            <div className={styles.riskcontent} key={index}>
                                <div className={styles.item}>
                                    <h4>{v.attr}</h4>
                                    <p>{v.aremark}</p>
                                    {
                                        v.atype == 'InputNumber' &&
                                        <div>
                                            <InputNumber
                                                inputStyle={{ width: '100px' }}
                                                placeholder='请输入'
                                                // defaultValue={v.paramValue}
                                                value={v.paramValue}
                                                precision={v.aprecision}
                                                min={v.amin}
                                                max={v.amax}
                                                onChange={(value) => {
                                                    let arrt = this.state.riskList.map((item) => {
                                                        if (item.paramCode == v.paramCode) {
                                                            item.paramValue = value ? value : v.amin;
                                                            return item;
                                                        }
                                                        return item;
                                                    });
                                                    this.setState({ riskList: arrt });
                                                }}
                                            />
                                        </div>
                                    }
                                    {
                                        v.atype == 'Switch' &&
                                        <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                                            <Switch
                                                checkedChildren="ON"
                                                unCheckedChildren="OFF"
                                                checked={v.paramValue == 1 ? true : false}
                                                onChange={(value) => {
                                                    let arrt = this.state.riskList.map((item) => {
                                                        if (item.paramCode == v.paramCode) {
                                                            item.paramValue = value ? 1 : 0;
                                                            return item;
                                                        }
                                                        return item;
                                                    });
                                                    this.setState({ riskList: arrt });
                                                }}
                                            />
                                        </div>
                                    }
                                    {
                                        v.atype == 'CheckboxGroup' &&
                                        <div>
                                            <Checkbox.Group
                                                value={[
                                                    v.paramValue.split(';')[0] == 0 ? undefined : 'first',
                                                    v.paramValue.split(';')[1] == 0 ? undefined : 'last'
                                                ]}
                                                options={v.list}
                                                onChange={values => {
                                                    let arrt = this.state.riskList.map((item) => {
                                                        if (item.paramCode == v.paramCode) {
                                                            let paramValue = '0;0';
                                                            if (values[0] == 'first' && values[1] == 'last') {
                                                                paramValue = '1;1'
                                                            } else if (values[0] == 'first') {
                                                                paramValue = '1;0'
                                                            } else if (values[0] == 'last') {
                                                                paramValue = '0;1'
                                                            } else {
                                                                paramValue = '0;0'
                                                            }
                                                            item.paramValue = paramValue;
                                                            return item;
                                                        }
                                                        return item;
                                                    });
                                                    this.setState({ riskList: arrt });
                                                }} />
                                        </div>
                                    }
                                    {
                                        v.atype === 'TextArea' &&
                                        <div>
                                            <Input.TextArea rows={2}
                                                value={v.paramValue}
                                                onChange={(e) => {
                                                    let arrt = this.state.riskList.map((item) => {
                                                        if (item.paramCode == v.paramCode) {
                                                            item.paramValue = e.target.value.replace('，', ',');
                                                            return item;
                                                        }
                                                        return item;
                                                    });
                                                    this.setState({ riskList: arrt });
                                                }}
                                            ></Input.TextArea>
                                        </div>
                                    }
                                </div>
                            </div>
                        );
                    }) : null}
                    {(!spinLoading && riskList.length === 0) ? <Empty /> : null}
                </div>
                <div className={styles.layout}>
                    <XOKButton loading={loading} onClick={this._savehandle} style={{ marginTop: '30px' }} label='保存' />
                </div>
            </div>
        );
    }
}

RiskControl.propTypes = {
    listAdminParamByParamType: PropTypes.array,
    getlistAdminParamByParamType: PropTypes.func,//参数数据(action)
};

const mapStateToProps = (state) => ({
    listAdminParamByParamType: state.parameter.listAdminParamByParamType,
});

export default connect(mapStateToProps, { ...model.actions })(RiskControl);
